<div class="container mt-0 mt-lg-3">
  <fgb-route-nav indicatorStyle="rounded">
    <a
      class="nav-item"
      [routerLink]="['/payment']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ "navbar.payment" | translate }}</label>
      <div class="nav-item-bg"></div>
    </a>
    <a
      class="nav-item"
      [routerLink]="['/payment/history']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ "navbar.ecash.history" | translate }}</label>
      <div class="nav-item-bg"></div>
    </a>
  </fgb-route-nav>
</div>
